import { useTranslation } from 'react-i18next'
import { FolderOpen }     from 'lucide-react'
import { PageHeader, Card } from '@/components/ui/primitives'

export default function MaterialsPage() {
  const { t } = useTranslation()
  return (
    <div className="space-y-6">
      <PageHeader
        title={t('nav.materials')}
        subtitle="Manage course materials and resources"
      />
      <Card>
        <div className="flex flex-col items-center justify-center py-16 text-center">
          <FolderOpen size={48} className="text-purple-400 mb-4" />
          <h3 className="font-semibold text-white/72 mb-1">Materials coming soon</h3>
          <p className="text-sm text-white/45 max-w-xs">
            Upload and organize PDFs, videos, and course materials for students.
          </p>
        </div>
      </Card>
    </div>
  )
}

